import React from "react";
import { Button, Table } from "react-bootstrap";

const VerifyRecordTable = ({ failData, handleVerify, verifyStatus }) => {
  if (!failData || failData.length === 0) {
    return <p>No data available</p>;
  }

  // Extract headings dynamically from the first object in the data array
  const headings = Object.keys(failData[0]);
  return (
    <>
      {/* <Row className="d-flex flex-row p-2 mt-5">
        <Col className="d-flex flex-row justify-content-end">
          <Row>
            <Col>
              <Button
                // onClick={handleRerun}
                className="btn-outline-steel-blue btn-light me-2 dropdown-custom-color"
              >
                <i className="fa fa-check"></i> Verify
              </Button>
            </Col>

           
           
          </Row>
        </Col>
      </Row> */}
      <div className="table-container">
        <Table striped bordered hover>
          <thead>
            <tr>
              {headings.map((heading, index) => (
                <th key={index}>{heading}</th>
              ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {failData.map((item, index) => (
              <tr key={index}>
                {headings.map((heading, idx) => (
                  <td key={idx}>{item[heading]}</td>
                ))}

                {/* <td style={{width:"100px", height:"100px"}}><Loading/></td> */}
                <td>
                  <Button variant="success" disabled={verifyStatus[index] === "Verified"}
                  onClick={()=>handleVerify(item, index)}
                >
                  <i className="fas fa-check"></i>{" "}
                  {verifyStatus[index] === "Verifying"
                    ? "Verifying"
                    : verifyStatus[index] === "Verified"
                    ? "Verified"
                    : "Verify"}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default VerifyRecordTable;
